export default __webpack_public_path__ + "static/media/chevron-right.166d4c94.svg";